import { Reducer } from "redux";

import { Types } from "@sendum/core";

import { DispatchAction } from "./PalletSelectorStore";
import { PalletSelectorActionTypes } from "./PalletSelectorActions";
import { sortPallets } from "../utils";

export interface IPalletSelectorState {
	error?: Error;
	isInitialLoading: boolean;
	isLoading?: boolean;
	pallets: Types.Pallet[];
	pallet?: Types.Pallet;
	account?: Types.Account;
}

const initialState: IPalletSelectorState = {
	pallets: [],
	isInitialLoading: false,
};

export const PalletSelectorReducer: Reducer<IPalletSelectorState, DispatchAction> = (state = initialState, action) => {
	switch (action.type) {
		case PalletSelectorActionTypes.RESET_STATE: {
			return { ...initialState };
		}
		case PalletSelectorActionTypes.END_INITIAL_LOADING: {
			return { ...state, ...{ isInitialLoading: false } };
		}
		case PalletSelectorActionTypes.SET_ERROR: {
			return { ...state, error: action.payload.error };
		}
		case PalletSelectorActionTypes.SET_LOADING: {
			return { ...state, isLoading: action.payload.isLoading };
		}
		case PalletSelectorActionTypes.SET_PALLETS: {
			return {
				...state,
				pallets: (action.payload.pallets ?? []).sort(sortPallets),
				pallet: action.payload.pallets?.find(_ => _.PalletId === state.pallet?.PalletId) ?? action.payload.pallets?.find(_ => _.Batch.BatchId === state.pallet?.PalletId && +_.PalletNumber === 1) ,
			};
		}
		case PalletSelectorActionTypes.SET_PALLET: {
			return { ...state, pallet: action.payload.pallet };
		}
		case PalletSelectorActionTypes.SET_ACCOUNT: {
			return { ...state, account: action.payload.account };
		}
		default:
			return state;
	}
};
